import { render, staticRenderFns } from "./ConsentToggleButton.vue?vue&type=template&id=2bcb6aa0&scoped=true"
import script from "./ConsentToggleButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConsentToggleButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ConsentToggleButton.vue?vue&type=style&index=0&id=2bcb6aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb6aa0",
  null
  
)

export default component.exports